import { Injectable, Type, inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class DialogService {
  private dialog = inject(MatDialog);


  // Just delegate to the Angular Material dialog service
  open<T, R = any>(
    component: Type<T>,
    config: MatDialogConfig = {}
  ): MatDialogRef<T, R> {
    return this.dialog.open(component, config);
  }

  // Open a dialog with some default settings
  openDialog<T, R = any>(
    component: Type<T>,
    config: MatDialogConfig = {}
  ): MatDialogRef<T, R> {
    return this.dialog.open(component, {
      width: config.width || '600px',  // Default width unless specified
      maxWidth: config.maxWidth || '80vw',
      maxHeight: config.maxHeight || '90vh',
      panelClass: 'standard-dialog',
      ...config, // Spread user-provided config
    });
  }

  openNearFullscreenDialog<T, R = any>(
    component: Type<T>,
    config: MatDialogConfig = {}
  ): MatDialogRef<T, R> {
    return this.dialog.open(component, {
      width: '98vw',
      height: '98vh',
      maxWidth: '98vw',
      maxHeight: '98vh',
      panelClass: 'near-fullscreen-dialog',
      ...config, // Allow overrides
    });
  }

  openFullscreenDialog<T, R = any>(
    component: Type<T>,
    config: MatDialogConfig = {}
  ): MatDialogRef<T, R> {
    return this.dialog.open(component, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'fullscreen-dialog',
      ...config, // Allow overrides
    });
  }
}